import { ProfileTopTabsProps, TopTab, TopTabResource } from './types';

export const getProfileTopTabs = ({ path, redirect, isAdmin }: ProfileTopTabsProps): TopTab[] => {

  const tabs: TopTab[] = [
    {
      path: '/dashboard/profile/me',
      label: 'Profile',
      isActive: path === '/dashboard/profile/me',
      onChange: () => { redirect('/dashboard/profile/me'); },
    },
  ];

  tabs.push({
    path: '/dashboard/profile/notifications',
    label: 'Notifications',
    isActive: path === '/dashboard/profile/notifications',
    onChange: () => { redirect('/dashboard/profile/notifications'); },
  });

  if (isAdmin) {
    tabs.push({
      path: '/dashboard/profile/admin',
      label: 'Admin',
      isActive: path === '/dashboard/profile/admin',
      onChange: () => { redirect('/dashboard/profile/admin'); },
    });
  }

  return tabs;
};

export const getProfileBillingTopTabs = ({ path, redirect }: ProfileTopTabsProps): TopTab[] => {

  const tabs: TopTab[] = [
    {
      path: '/dashboard/profile/billing/plan',
      label: 'Plan',
      isActive: path === '/dashboard/profile/billing/plan',
      onChange: () => { redirect('/dashboard/profile/billing/plan'); },
    },
    {
      path: '/dashboard/profile/billing/payment-method',
      label: 'Payment Method',
      isActive: path === '/dashboard/profile/billing/payment-method',
      onChange: () => { redirect('/dashboard/profile/billing/payment-method'); },
    },
    {
      path: '/dashboard/profile/billing/invoices',
      label: 'Invoices',
      isActive: path === '/dashboard/profile/billing/invoices',
      onChange: () => { redirect('/dashboard/profile/billing/invoices'); },
    },
    {
      path: '/dashboard/profile/billing/credit-history',
      label: 'Credit History',
      isActive: path === '/dashboard/profile/billing/credit-history',
      onChange: () => { redirect('/dashboard/profile/billing/credit-history'); },
    },
  ];

  return tabs;
};

export const getUserTopTabs = ({ path, redirect, isAdmin, id }: ProfileTopTabsProps): TopTab[] => {
  const tabs: TopTab[] = [
    {
      path: '/dashboard/admin/users/:id/profile',
      label: 'Profile',
      isActive: path === '/dashboard/admin/users/:id/profile',
      onChange: () => { redirect(`/dashboard/admin/users/${id}/profile`); },
    },
  ];

  tabs.push({
    path: '/dashboard/admin/users/:id/notifications',
    label: 'Notifications',
    isActive: path === '/dashboard/admin/users/:id/notifications',
    onChange: () => { redirect(`/dashboard/admin/users/${id}/notifications`); },
  });

  if (isAdmin) {
    tabs.push({
      path: '/dashboard/admin/users/:id/admin',
      label: 'Admin',
      isActive: path === '/dashboard/admin/users/:id/admin',
      onChange: () => { redirect(`/dashboard/admin/users/${id}/admin`); },
    });
  }


  return tabs;
};

export const getUserBillingTopTabs = ({ path, redirect, id }: ProfileTopTabsProps): TopTab[] => {
  return [
    {
      path: '/dashboard/admin/users/:id/billing/plan',
      label: 'Plan',
      isActive: path === '/dashboard/admin/users/:id/billing/plan',
      onChange: () => {
        redirect(`/dashboard/admin/users/${id}/billing/plan`);
      },
    },
    {
      path: '/dashboard/admin/users/:id/billing/payment-method',
      label: 'Payment Method',
      isActive: path === '/dashboard/admin/users/:id/billing/payment-method',
      onChange: () => {
        redirect(`/dashboard/admin/users/${id}/billing/payment-method`);
      },
    },
    {
      path: '/dashboard/admin/users/:id/billing/invoices',
      label: 'Invoices',
      isActive: path === '/dashboard/admin/users/:id/billing/invoices',
      onChange: () => {
        redirect(`/dashboard/admin/users/${id}/billing/invoices`);
      },
    },
    {
      path: '/dashboard/admin/users/:id/billing/credit-history',
      label: 'Credit History',
      isActive: path === '/dashboard/admin/users/:id/billing/credit-history',
      onChange: () => {
        redirect(`/dashboard/admin/users/${id}/billing/credit-history`);
      },
    },
  ];
};

export const getTopTabs = (tabResource: TopTabResource, data: ProfileTopTabsProps): TopTab[] => {
  switch (tabResource) {
    case 'profileUser':
      return getProfileTopTabs(data);
    case 'user':
      return getUserTopTabs(data);
    case 'profileBilling':
      return getProfileBillingTopTabs(data);
    case 'billing':
      return getUserBillingTopTabs(data);
    default:
      return [];
  }
};
